import { render, staticRenderFns } from "./RoomTitleInput.vue?vue&type=template&id=2d5e5b42&lang=pug&"
import script from "./RoomTitleInput.vue?vue&type=script&lang=js&"
export * from "./RoomTitleInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomTitleInput.vue"
export default component.exports